import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRefreshCcw01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.341 6.345a8 8 0 1 1-2.029 7.878 1 1 0 0 0-1.921.554C3.594 18.948 7.439 22 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2a9.972 9.972 0 0 0-7.074 2.931C4.29 5.568 3.606 6.358 3 7.094V4a1 1 0 0 0-2 0v6a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2H4.03c.685-.859 1.547-1.89 2.311-2.655Z"
    />
  </svg>
);
SvgRefreshCcw01.displayName = 'RefreshCcw01';
export default SvgRefreshCcw01;
